/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Application = /** @class */function () {
  function Application() {}
  return Application;
}();
export { Application };